var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExceptionreport = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.182,
    height: 22.202,
    viewBox: "0 0 20.182 22.202",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-reports-4422796",
    transform: "translate(-123.495 -30.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M138.036,90.879h-2.209v1.4h2.167V109H124.9V92.282h2.167v-1.4h-2.209a1.362,1.362,0,0,0-1.361,1.361v16.806a1.362,1.362,0,0,0,1.361,1.361h13.181a1.362,1.362,0,0,0,1.361-1.361V92.24a1.362,1.362,0,0,0-1.36-1.36Z",
    transform: "translate(0 -57.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M220.025,36.25h6.041a.66.66,0,0,0,.659-.66V33.615a.659.659,0,0,0-.659-.659H224.92a1.816,1.816,0,0,0,.017-.246,1.893,1.893,0,1,0-3.786,0,2.11,2.11,0,0,0,.017.246h-1.144a.659.659,0,0,0-.66.659v1.977a.659.659,0,0,0,.66.659Zm3.02-4.33a.789.789,0,1,1-.79.789A.789.789,0,0,1,223.045,31.92Z",
    transform: "translate(-91.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    d: "M515.59,223.37H518.3V233.4H515.59Z",
    transform: "translate(-374.627 -183.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M517.147,159.77h-.4a1.157,1.157,0,0,0-1.155,1.155v.975H518.3v-.975A1.157,1.157,0,0,0,517.147,159.77Z",
    transform: "translate(-374.626 -123.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M518.728,466.56a.35.35,0,0,0,.651,0l.932-2.323H517.8Z",
    transform: "translate(-376.734 -414.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M183.63,178.75h3.379v2.884H183.63Z",
    transform: "translate(-57.456 -141.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M288.3,199.29h6.129v1.053H288.3Z",
    transform: "translate(-157.463 -160.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M183.63,286.93h3.379v2.883H183.63Z",
    transform: "translate(-57.456 -244.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M288.3,307.46h6.129v1.053H288.3Z",
    transform: "translate(-157.463 -264.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M183.63,395.1h3.379v2.883H183.63Z",
    transform: "translate(-57.456 -348.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M288.3,415.64h6.129v1.052H288.3Z",
    transform: "translate(-157.463 -367.679)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExceptionreport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exceptionreport.60287137.svg";
export { ForwardRef as ReactComponent };